import { ILinkData } from '../PageSwitch/ILinkData';
import PageHandler from '../PageSwitch/PageHandler';

const isDataObject = (data: ILinkData | string): data is ILinkData => {
	return typeof data === 'string' ? false : !!data.link || !!data.internalLink;
};

export const GetLinkData = (data: ILinkData | string) => {
	let link: string | undefined;
	let title: string | undefined;
	if (isDataObject(data)) {
		if (data.title) {
			title = data.title;
		} else if (data.internalLink && data.internalLink.title) {
			title = data.internalLink.title;
		}

		if (data.link) {
			link = data.link;
		} else if (data.internalLink) {
			link = data.internalLink._prefix + (data.internalLink.slug ? data.internalLink.slug : '');
		} else {
			console.error('No link or internalLink found on ' + JSON.stringify(data));
			return;
		}
	} else if (typeof data === 'string') {
		link = `${data}`;
	}

	if (!link) {
		console.error('No link found on ' + JSON.stringify(data));
		return;
	}

	const url = new URL(link, 'https://example.com');
	let href = url.href;
	let target: string | undefined;
	let local = false;

	if (url.origin === 'https://example.com' || url.host === 'www.smukfest.dk') {
		href = url.href.replace(url.origin, '');
		local = true;
	} else {
		target = '_blank';
	}

	return {
		href,
		target,
		title: title,
		local,
		open: (props: { target?: string } = {}) => {
			const openTarget = props.target ?? target;

			if (!url.origin) {
				// it is most likely a mailto: or tel: url
				window.location.href = href;
			} else if (local && (!openTarget || openTarget === '_self')) {
				// open in the same window, means its a local link
				PageHandler.getInstance().goto(href);
			} else {
				// external link
				window.open(href, openTarget);
			}
		},
	};
};
